<template>
    <div class="header-row">
        <h3 class="h3 dashboard__title">
            <i18n-t keypath="dashboard.myOrders" />
        </h3>
        <div
            v-if="companyFinancialDto?.default_order_flow?.on_credit"
            class="deferal-wrapper dashboard__title"
        >
            <img src="/img/credit.svg" alt="" />
            <div class="deferal-content">
                <span class="credit-limit-text">
                    <i18n-t keypath="cart.creditLimit" />
                </span>
                <span class="credit-limit-value">
                    <b>€ {{ creditRemaining }}</b>
                    / € {{ creditLimit }}
                </span>
            </div>
        </div>
    </div>
    <div class="dashboard__tabs" data-version="2">
        <!-- <div
            class="
                dashboard__tabs-item
                dashboard__tabs-item--separate
                dashboard__tabs-item--white
                dashboard__tabs-item--mr
            "
            :class="{ 'is-active': !activeItem }"
        >
            <router-link
                class="dashboard__tabs-link c-link-height"
                :to="{ path: '/auth/my-carconnex/my-orders/to_approve' }"
            >
                <div class="top">
                    <strong
                        data-version="2"
                        :data-inc="
                            orderDetails?.to_approve?.orders_action_required_counter
                        "
                        :class="{
                            'no-circle-number':
                                orderDetails?.to_approve
                                    ?.orders_action_required_counter === undefined ||
                                orderDetails?.to_approve
                                    .orders_action_required_counter === 0,
                        }"
                    >
                        <b><i18n-t keypath="myOrders.all" /></b>
                        <span class="c-text-weight"></span>
                        <span class="num">
                            {{ orderDetails?.all }}
                        </span>
                    </strong>
                </div>
            </router-link>
        </div> -->
        <div class="dashboard__tabs-item-group">
            <div
                class="dashboard__tabs-item dashboard__tabs-item--white"
                :class="{
                    'is-active':
                        orderStatusEnum[activeItem] === orderStatusEnum?.to_approve,
                }"
            >
                <router-link
                    :to="{
                        path: `/auth/my-carconnex/my-orders/${ordersStatus?.to_approve}`,
                    }"
                    class="dashboard__tabs-link c-link-height"
                >
                    <div class="top">
                        <strong
                            data-version="2"
                            :data-inc="
                                orderDetails?.to_approve?.orders_action_required_counter
                            "
                            :class="{
                                'no-circle-number':
                                    orderDetails?.to_approve
                                        ?.orders_action_required_counter === undefined ||
                                    orderDetails?.to_approve
                                        .orders_action_required_counter === 0,
                            }"
                        >
                            <i18n-t keypath="myOrders.to_approve.title" />
                            <span class="num">
                                {{ orderDetails?.to_approve?.orders_counter }}
                            </span>
                        </strong>
                    </div>
                </router-link>
            </div>

            <div
                class="dashboard__tabs-item dashboard__tabs-item--white"
                :class="{
                    'is-active': orderStatusEnum[activeItem] === orderStatusEnum.on_order,
                }"
            >
                <router-link
                    :to="{
                        path: `/auth/my-carconnex/my-orders/${ordersStatus.on_order}`,
                    }"
                    class="dashboard__tabs-link c-link-height"
                >
                    <div class="top">
                        <strong class="no-circle-number" data-version="2">
                            <i18n-t keypath="myOrders.on_order.title" />
                            <span class="num">
                                {{ orderDetails?.on_order?.orders_counter }}
                            </span>
                        </strong>
                        <p
                            class="custom-icon"
                            v-tippy="{
                                content: noAvailableForTransportText,
                                placement: 'top',
                                interactive: true,
                                hideOnClick: true,
                            }"
                        >
                            <span>?</span>
                        </p>
                    </div>
                </router-link>
            </div>
            <template v-for="(tab, index) in tabsInfo" :key="index">
                <div
                    class="dashboard__tabs-item dashboard__tabs-item--white"
                    :class="{
                        'is-active': orderStatusEnum[activeItem] === tab?.orderStatus,
                    }"
                >
                    <router-link
                        :to="{
                            path: `/auth/my-carconnex/my-orders/${tab?.path}`,
                        }"
                        class="dashboard__tabs-link c-link-height"
                    >
                        <div class="top">
                            <strong
                                data-version="2"
                                :data-inc="getValue(tab, true)"
                                :class="{
                                    'no-circle-number':
                                        getValue(tab, true) === undefined ||
                                        getValue(tab, true) === 0,
                                }"
                            >
                                {{ i18n.t(tab?.title) }}
                                <span class="num">
                                    {{ getValue(tab) }}
                                </span>
                            </strong>
                            <p
                                class="custom-icon"
                                v-tippy="{
                                    content:
                                        tab.orderStatus === orderStatusEnum.to_pay
                                            ? i18n.t('myOrders.availableForTransport')
                                            : i18n.t('myOrders.noInfo'),
                                    placement: 'top',
                                    interactive: true,
                                }"
                            >
                                <span>?</span>
                            </p>
                        </div>
                    </router-link>
                </div>
            </template>

            <div
                class="dashboard__tabs-item dashboard__tabs-item--white"
                :class="{
                    'is-active':
                        orderStatusEnum[activeItem] ===
                        orderStatusEnum.processing_documents,
                }"
            >
                <router-link
                    :to="{
                        path: `/auth/my-carconnex/my-orders/${ordersStatus.processing_documents}`,
                    }"
                    class="dashboard__tabs-link c-link-height"
                >
                    <div class="top">
                        <b></b>
                        <strong
                            data-version="2"
                            :data-inc="
                                orderDetails?.processing_documents
                                    ?.orders_action_required_counter
                            "
                            :class="{
                                'no-circle-number':
                                    orderDetails?.processing_documents
                                        ?.orders_action_required_counter === undefined ||
                                    orderDetails?.processing_documents
                                        ?.orders_action_required_counter === 0,
                            }"
                        >
                            <i18n-t keypath="myOrders.processing_documents.title" />
                            <span class="num">
                                {{ orderDetails?.processing_documents?.orders_counter }}
                            </span>
                        </strong>
                    </div>
                </router-link>
            </div>
        </div>

        <div
            class="
                dashboard__tabs-item
                dashboard__tabs-item--separate
                dashboard__tabs-item--white
                dashboard__tabs-item--ml
            "
            :class="{
                'is-active': orderStatusEnum[activeItem] === orderStatusEnum?.completed,
            }"
        >
            <router-link
                class="dashboard__tabs-link c-link-height"
                :to="{
                    path: `/auth/my-carconnex/my-orders/${ordersStatus?.completed}`,
                }"
            >
                <b><i18n-t keypath="myOrders.completed.title" /></b>
                <span class="c-text-weight">
                    {{ orderDetails?.completed?.orders_counter }}
                </span>
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import { OrdersTabs } from "@/dashboard/my-orders/orders-tabs/orders-tabs";

export default OrdersTabs;
</script>

<style lang="scss">
.c-text-weight {
    font-weight: 500;
    margin-left: 5px;
}
.c-link-height {
    min-height: 61px !important;
}

.c-tabs-margin {
    margin-bottom: 2rem !important;
}
.top {
    display: inline-flex;
    .custom-icon {
        cursor: pointer;
        width: 16px;
        height: 16px;
        border-radius: 100px;
        border: 1px solid gray;
        margin-left: 5px;
        text-align: center;
        span {
            margin-left: 1px;
            top: -1px;
            position: relative;
            font-size: 12px;
            font-weight: normal;
        }
    }
}
.header-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.deferal-wrapper {
    display: flex;
    flex-direction: row;
    gap: 12px;
}
.deferal-content {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}
.credit-limit-text {
    font-family: var(--font-family);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
    text-wrap: nowrap;
}
.credit-limit-value {
    font-family: var(--font-family);
    font-size: 15px;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    text-wrap: nowrap;
    min-width: 200px; // fix to avoid that the text does not fit into the dimensions
}
</style>
